import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';
import BaseRolePerimeter from '@/kindergarten/perimeters/BaseRolePerimeter';
import GuestPerimeter from '@/kindergarten/perimeters/GuestPerimeter';
import AuthPerimeter from '@/kindergarten/perimeters/AuthPerimeter';
import AdminPerimeter from '@/kindergarten/perimeters/AdminPerimeter';
import VertriebPerimeter from '@/kindergarten/perimeters/VertriebPerimeter';

export const perimeters = {
  BasePerimeter,
  GuestPerimeter,
  AuthPerimeter,
  AdminPerimeter,
  BaseRolePerimeter,
  VertriebPerimeter,
};

export const redirectRoutes = {
  GuestPerimeter: 'home.index',
  AuthPerimeter: 'login.index',
  AdminPerimeter: 'login.index',
  BaseRolePerimeter: 'home.index',
  VertriebPerimeter: 'login.index',
};



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/index.js